import {
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
} from '@angular/core';

@Component({
  selector: 'app-guided-tour-progress-bar',
  templateUrl: './guided-tour-progress-bar.component.html',
  styleUrl: './guided-tour-progress-bar.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GuidedTourProgressBarComponent {
  currentStep = input(0);

  totalSteps = input(0);

  progress = computed(() => {
    if (this.totalSteps() === 0 || this.currentStep() === 0) {
      return 0;
    }

    return (this.currentStep() / this.totalSteps()) * 100;
  });
}
